/* Livish fixes part 4 (17 Oct 2026). Two small scripts; each only acts on its own buttons. */
/* Livish (17 Oct 2026): cart page "Complete your order" picks add the product
   without reloading the page. The theme refreshes the cart list, totals and
   counts itself ("cart:refresh"). If the list did not change, reload as before. */
(function () {
  var ar = /^ar/i.test(document.documentElement.lang || '');
  function tx(en, a) { return ar ? a : en; }
  function lines() { return document.querySelectorAll('.t4s-cartPage__items .t4s-page_cart__item').length; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lv-xsell [data-lv-add]');
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (b.disabled) return;
    var card = b.closest('.lv-xs-card'), old = card && card.querySelector('.lv-xs-card__err');
    if (old) old.remove();
    var label = b.textContent, before = lines();
    b.disabled = true;
    b.textContent = tx('Adding…', 'جارٍ الإضافة…');
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-lv-add')), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        b.classList.add('is-done');
        b.textContent = tx('Added ✓', 'تمت الإضافة ✓');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { if (lines() === before) window.location.reload(); }, 4000);
      })
      .catch(function (err) {
        b.disabled = false;
        b.textContent = label;
        if (!card) return;
        var p = document.createElement('p');
        p.className = 'lv-xs-card__err';
        p.textContent = (err && (err.description || err.message)) || tx('Could not add. Please try again.', 'تعذرت الإضافة، حاول مرة أخرى.');
        card.appendChild(p);
      });
  }, true);
})();
/* Livish (17 Oct 2026): faster cart drawer after "Add to cart" in the AI search
   (Ryzo) results. The add itself takes about 1 s; before, the drawer waited
   another 1.5-2 s for other apps' cart calls. Now the drawer refreshes and opens
   as soon as the add is done. Only for adds started from a Ryzo button. */
(function () {
  var last = 0;
  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest && e.target.closest('#ryzoContent button, #ryzoContent [class*="add-to-cart"], [class*="ryzo"] [class*="add-to-cart"]');
    if (t) last = Date.now();
  }, true);
  if (!('PerformanceObserver' in window)) return;
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (en) {
        if (!/\/cart\/add(\.js)?(\?|$)/.test(en.name) || Date.now() - last > 8000) return;
        last = 0;
        var sp = window.T4SThemeSP, $ = window.jQuery || window.$;
        if (sp) sp.isATCSuccess = true;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        try { if (sp && sp.Drawer && $) sp.Drawer.opend($('#t4s-mini_cart')); } catch (x) {}
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (x) {}
})();
/* Livish (17 Oct 2026): Face Age skin analysis loads on demand. Its 2.4 MB of
   scripts were downloaded and run on every page; now they load when the
   shopper opens the Vee AI menu or taps "Skin analysis", or on the
   skin-analysis page itself. The tap waits until the app is ready, then opens it. */
(function () {
  var shop = (window.Shopify && Shopify.shop) || 'dailydeals-kw.myshopify.com';
  var SRC = 'https://cdn.jsdelivr.net/npm/face-age?shop=' + shop;
  var started = false;
  function load() {
    if (started || window.FaceAge || document.querySelector('script[src*="npm/face-age"]')) return;
    started = true;
    var s = document.createElement('script');
    s.src = SRC; s.async = true;
    document.head.appendChild(s);
  }
  if (document.getElementById('faceAge-module')) load();
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('[data-toolbar-fab], [data-livish-floating], [data-open-face-age], [data-livish-floating-face-age]')) load();
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-open-face-age], [data-livish-floating-face-age]');
    if (!a || document.getElementById('face-age-button')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (a.classList.contains('lv-fa-wait')) return;
    load();
    a.classList.add('lv-fa-wait');
    var n = 0, t = setInterval(function () {
      n++;
      if (document.getElementById('face-age-button')) {
        clearInterval(t); a.classList.remove('lv-fa-wait'); a.click();
      } else if (n > 120) {
        clearInterval(t); a.classList.remove('lv-fa-wait');
      }
    }, 250);
  }, true);
})();

/* Free delivery on all orders (17 Oct 2026): English cart note. Arabic is set in translations. */
(function () {
  if (/^ar/i.test(document.documentElement.lang || '')) return;
  var re = /^\s*(Delivery fee is shown at checkout|Taxes and shipping calculated at checkout)\.?\s*$/;
  var q = 0;
  function fix() {
    q = 0;
    document.querySelectorAll('.t4s-cart__tax, .t4s-cart-total-tax, .t4s-mini_cart__tax, [class*="tax"] p, [class*="tax"] small, [class*="tax"]').forEach(function (el) {
      if (el.childElementCount === 0 && re.test(el.textContent)) el.textContent = 'Free delivery on all orders';
    });
  }
  function watch(el) { if (el) new MutationObserver(function () { if (!q) q = setTimeout(fix, 60); }).observe(el, { childList: true, subtree: true }); }
  function start() { fix(); watch(document.getElementById('t4s-mini_cart')); if (/template-cart/.test(document.body.className)) watch(document.getElementById('MainContent')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* Cart page limited-time offer (17 Oct 2026): loads livish-cart-offer.js on the cart page only. Remove this block to switch it off.
   OFFER_VER: change it whenever livish-cart-offer.js changes, so phones load the new file instead of a cached copy. */
(function () {
  if (!/template-cart/.test(document.body.className)) return;
  var OFFER_VER = '20261019-10';
  var me = document.querySelector('script[src*="livish-fixes-4.js"]');
  if (!me) return;
  var s = document.createElement('script');
  s.src = me.src.replace('livish-fixes-4.js', 'livish-cart-offer.js').replace(/([?&])v=[^&]*/, '$1v=' + OFFER_VER); s.defer = true;
  document.body.appendChild(s);
})();

/* Filter bottom sheet (17 Oct 2026): on phone/tablet, tapping the dark area behind an open filter closes it. */
(function () {
  document.addEventListener('click', function (e) {
    var d = e.target;
    if (window.innerWidth > 1024 || !d || !d.matches || !d.matches('[data-livish-filter-dropdown][open]')) return;
    e.preventDefault();
    d.removeAttribute('open');
  }, true);
})();

/* Livish (18 Oct 2026): footer "Become a Vendor" tab. A copy of the last footer tab (Newsletter Signup), so it has the exact same look and spacing, with its own text: a short note and the apply link. EN/AR. Undo: delete this block. */
(function () {
  var ar = /^ar/i.test(document.documentElement.lang || '');
  function add() {
    var foot = document.getElementById('t4s-footer');
    if (!foot || foot.querySelector('.lv-vendor-tab')) return;
    var heads = foot.querySelectorAll('.t4s-col-heading');
    if (!heads.length) return;
    var lastHead = heads[heads.length - 1];
    var col = lastHead.closest('.t4s-col-item') || lastHead.parentElement;
    if (!col || !col.parentNode) return;
    var tab = col.cloneNode(true);
    tab.classList.add('lv-vendor-tab');
    tab.removeAttribute('id');
    tab.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
    /* The theme has two headings per column: one for desktop, one for phones (with the + icon). Keep both, drop the copied Newsletter content. */
    var hs = tab.querySelectorAll('.t4s-col-heading');
    if (!hs.length) return;
    var label = ar ? 'انضم كمورّد' : 'Become a Vendor';
    Array.prototype.forEach.call(hs, function (h) {
      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT), tn, done = false;
      while ((tn = walker.nextNode())) { if (tn.nodeValue.trim()) { tn.nodeValue = done ? '' : label; done = true; } }
      if (!done) h.insertBefore(document.createTextNode(label), h.firstChild);
    });
    var inner = hs[0].closest('.t4s-col-inner') || hs[0].parentNode.parentNode;
    Array.prototype.slice.call(inner.children).forEach(function (n) {
      if (!(n.classList.contains('t4s-col-heading') || n.querySelector('.t4s-col-heading'))) n.remove();
    });
    var body = document.createElement('div');
    body.className = 'lv-vendor-tab__body';
    body.style.cssText = 'padding:4px 0 14px;font-size:14px;line-height:1.6;color:#555';
    var p = document.createElement('p');
    p.style.margin = '0 0 6px';
    p.textContent = ar ? 'لديك علامة عطور أو تجميل أو منتجات عناية؟ اعرض منتجاتك على ليفيش ووصّلها لعملاء في كل الكويت.' : 'Have a perfume, beauty or care brand? Sell on Livish and reach shoppers across Kuwait.';
    var a = document.createElement('a');
    a.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || (ar ? '/ar/' : '/')) + 'pages/become-a-vendor';
    a.textContent = ar ? 'قدّم الآن' : 'Apply now';
    a.style.cssText = 'color:#770114;font-weight:600;text-decoration:underline';
    body.appendChild(p); body.appendChild(a);
    inner.appendChild(body);
    var mob = tab.querySelector('.t4s-footer-heading-mobile') || hs[hs.length - 1];
    var open = false;
    function set(v) {
      open = v;
      body.style.setProperty('display', open ? 'block' : 'none', 'important');
      body.style.setProperty('visibility', 'visible', 'important');
      body.style.setProperty('height', 'auto', 'important');
      body.style.setProperty('opacity', '1', 'important');
      /* Same open state the theme gives its own tabs, so the + turns into - on phones. */
      inner.classList.toggle('is--footer_opened', open && getComputedStyle(mob).display !== 'none');
    }
    mob.style.cursor = 'pointer';
    mob.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); mob.__lvUsed = 1; set(!open); }, true);
    function fit() { if (getComputedStyle(mob).display === 'none') set(true); else if (!mob.__lvUsed) set(false); }
    col.parentNode.insertBefore(tab, col.nextSibling);
    fit(); window.addEventListener('resize', fit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();

/* Livish (18 Oct 2026): collection pages.
   1) Phone filter sheet: the bottom bar (Home / Cart / Vee AI) is hidden while a filter is open, so the last row and the Filter / Reset buttons are not covered.
   2) (Switched off 19 Oct 2026 — see start().) In stock first: a collection opened with the "In stock" filter on (the same filter shoppers can use themselves). Shoppers can switch it off
      ("Show sold-out items" or the Availability filter) and it stays off for the rest of the visit. If nothing is sold out, or the filter is missing, nothing changes.
   3) After any filter / sort the product grid is replaced by the theme; the "Looking for more options?" row and the sold-out-last order are put back on the new grid.
   Undo: delete this block. */
(function () {
  if (!/template-collection/.test(document.body.className)) return;
  var ar = /^ar/i.test(document.documentElement.lang || '');

  var st = document.createElement('style');
  st.id = 'lv-stock-css';
  st.textContent = '@media (max-width:1024px){html body:has([data-livish-filter-dropdown][open]) .t4s-toolbar{display:none!important}' +
    '@supports not selector(:has(*)){html body .t4s-livish-filter [data-livish-filter-dropdown][open]>.t4s-livish-filter__menu{padding-bottom:calc(84px + env(safe-area-inset-bottom))!important}}}';
  document.head.appendChild(st);

  function params() { return new URLSearchParams(location.search); }
  function stockOnly() { var v = params().getAll('filter.v.availability'); return v.length === 1 && v[0] === '1'; }
  function facetCount(val) {
    var list = document.querySelectorAll('input[name="filter.v.availability"][value="' + val + '"]');
    for (var k = 0; k < list.length; k++) {
      var l = list[k].closest('label');
      var s = l && l.querySelector('[class*="__count"]');
      var n = s ? parseInt(s.textContent.replace(/\D/g, ''), 10) : NaN;
      if (!isNaN(n)) return n;
    }
    return null;
  }
  /* Same call the theme's own filter uses, so the page updates without a reload. */
  function nativeFilter(url) {
    var links = null;
    try {
      var c = document.querySelector('.t4s-main-collection-page[data-ntajax-container][data-ntajax-options]');
      var o = JSON.parse(c.getAttribute('data-ntajax-options'));
      var f = document.getElementById('shopify-section-' + o.typeFilters);
      links = f && f.querySelector('[data-filter-links]');
    } catch (e) {}
    if (!links) { location.href = url; return; }
    var a = document.createElement('a');
    a.href = url; a.hidden = true;
    links.appendChild(a); a.click(); a.remove();
  }
  function setAll() { try { sessionStorage.setItem('lv_all', '1'); } catch (e) {} }
  function showSoldOut() {
    setAll();
    var p = params(); p.delete('filter.v.availability'); p.delete('page');
    var q = p.toString();
    nativeFilter(location.pathname + (q ? '?' + q : ''));
  }

  /* "Looking for more options?" row (same look and data as the sitewide one). */
  function cleanText(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function normPath(h) {
    var v = (h || '').split('?')[0].split('#')[0];
    try { v = decodeURIComponent(v); } catch (e) {}
    return v.replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '').toLowerCase();
  }
  var MENU_SEL = '#shopify-section-livish-mega-menu a[href*="/collections/"], #shopify-section-mobile-categories-grid a[href*="/collections/"]';
  function menuIndex() {
    var map = {}, order = 0;
    document.querySelectorAll(MENU_SEL).forEach(function (a) {
      var k = normPath(a.getAttribute('href')), t = cleanText(a.textContent);
      if (!t || map[k]) return;
      var li = a.closest('li');
      map[k] = { href: a.getAttribute('href'), text: t, leaf: !(li && li.classList.contains('has-children')), order: order++ };
    });
    return map;
  }
  function footerCategories() {
    var out = [], heads = document.querySelectorAll('#t4s-footer .t4s-col-heading');
    for (var k = 0; k < heads.length; k++) {
      if (!/^\s*(الفئات|Categories)\s*$/i.test(heads[k].textContent)) continue;
      var col = heads[k].closest('.t4s-col-inner') || heads[k].parentElement;
      col.querySelectorAll('a[href]').forEach(function (a) {
        var t = cleanText(a.textContent);
        if (t && out.length < 6) out.push({ href: a.getAttribute('href'), text: t });
      });
      break;
    }
    return out;
  }
  function siblingKeys(path, menu) {
    var here = normPath(path), out = [], links = document.querySelectorAll(MENU_SEL);
    for (var i = 0; i < links.length && !out.length; i++) {
      if (normPath(links[i].getAttribute('href')) !== here) continue;
      var list = links[i].closest('ul');
      if (!list) continue;
      list.querySelectorAll(':scope > li > a[href*="/collections/"]').forEach(function (a) {
        var k = normPath(a.getAttribute('href'));
        if (k !== here && menu[k] && out.indexOf(k) < 0) out.push(k);
      });
    }
    return out;
  }
  var relCache = {};
  function related(path) {
    if (relCache[path]) return relCache[path];
    var q = '?view=lvcats', pv = location.search.match(/preview_theme_id=\d+/);
    if (pv) q += '&' + pv[0];
    relCache[path] = fetch(path + q, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        if (!txt || /<html/i.test(txt)) return footerCategories();
        var menu = menuIndex(), here = normPath(path), prods = [], cur = [], counts = {};
        txt.split('\n').forEach(function (line) {
          line = line.trim();
          if (line === '--') { if (cur.length) prods.push(cur); cur = []; return; }
          if (!line) return;
          var k = normPath(line.split('|')[0]);
          if (k !== here && menu[k] && cur.indexOf(k) < 0) cur.push(k);
        });
        if (cur.length) prods.push(cur);
        prods.forEach(function (p) { p.forEach(function (k) { counts[k] = (counts[k] || 0) + 1; }); });
        var rank = function (a, b) { return (counts[b] - counts[a]) || (menu[a].order - menu[b].order); };
        var lists = prods.map(function (p) { return p.filter(function (k) { return menu[k].leaf; }).sort(rank); });
        var picked = [];
        while (picked.length < 6) {
          var added = false;
          lists.forEach(function (l) {
            while (l.length && picked.length < 6) {
              var k = l.shift();
              if (picked.indexOf(k) < 0) { picked.push(k); added = true; break; }
            }
          });
          if (!added) break;
        }
        if (picked.length < 4) siblingKeys(path, menu).forEach(function (k) { if (picked.length < 6 && k !== here && picked.indexOf(k) < 0) picked.push(k); });
        if (picked.length < 3) Object.keys(counts).filter(function (k) { return !menu[k].leaf && picked.indexOf(k) < 0; }).sort(rank).slice(0, 6 - picked.length).forEach(function (k) { picked.push(k); });
        var seen = {}, out = [];
        picked.forEach(function (k) {
          if (seen[menu[k].text]) return;
          seen[menu[k].text] = 1;
          out.push({ href: menu[k].href, text: menu[k].text });
        });
        return out.length ? out : footerCategories();
      })
      .catch(function () { return footerCategories(); });
    return relCache[path];
  }
  function build(list, stock) {
    var box = document.createElement('div');
    box.className = 'lv-more-options t4s-col-item';
    var title = document.createElement('p');
    title.className = 'lv-more-options__title';
    title.textContent = ar ? 'تبحث عن خيارات أكثر؟' : 'Looking for more options?';
    var sub = document.createElement('p');
    sub.className = 'lv-more-options__sub';
    sub.textContent = stock
      ? (ar ? 'المنتجات النافدة مخفية. تسوّق من الأقسام المشابهة أو اعرض المنتجات النافدة:' : 'Sold-out items are hidden. Shop similar categories or show the sold-out items:')
      : (ar ? 'المنتجات التالية نفدت حالياً. تسوّق من الأقسام المشابهة:' : 'These items are sold out right now. Shop similar categories:');
    var links = document.createElement('div');
    links.className = 'lv-more-options__links';
    if (stock) {
      var show = document.createElement('a');
      show.href = '#';
      show.className = 'lv-more-options__btn is--primary';
      show.textContent = ar ? 'عرض المنتجات النافدة' : 'Show sold-out items';
      show.addEventListener('click', function (e) { e.preventDefault(); showSoldOut(); });
      links.appendChild(show);
    }
    list.forEach(function (c) {
      var a = document.createElement('a');
      a.className = 'lv-more-options__btn';
      a.href = c.href;
      a.textContent = c.text;
      links.appendChild(a);
    });
    box.appendChild(title); box.appendChild(sub); box.appendChild(links);
    return box;
  }

  function busy(grid, fn) { grid.__lvBusy = 1; try { fn(); } finally { grid.__lvBusy = 0; } }
  function sortSold(grid) {
    var items = Array.prototype.filter.call(grid.children, function (el) { return el.classList.contains('t4s-product'); });
    var firstSold = -1, lastIn = -1;
    items.forEach(function (el, i) { if (el.classList.contains('is--sold-out')) { if (firstSold < 0) firstSold = i; } else lastIn = i; });
    if (items.length < 4 || firstSold < 0 || lastIn < firstSold) return;
    busy(grid, function () {
      items.forEach(function (el) { if (el.classList.contains('is--sold-out')) grid.appendChild(el); });
      var tail = grid.querySelector(':scope > .t4s-pagination, :scope > [class*="load-more"], :scope > [class*="loadmore"]');
      if (tail) grid.appendChild(tail);
    });
  }
  function banner(grid) {
    var box = grid.querySelector(':scope > .lv-more-options');
    var path = location.pathname;
    if (stockOnly()) {
      var more = document.querySelector('a.t4s-loadmore-btn');
      var moreLeft = !!(more && more.offsetParent !== null);
      if (moreLeft || facetCount(0) === 0 || !grid.querySelector(':scope > .t4s-product')) { if (box) busy(grid, function () { box.remove(); }); return; }
      if (box) { if (grid.lastElementChild !== box) busy(grid, function () { grid.appendChild(box); }); return; }
      if (grid.__lvLoading) return;
      grid.__lvLoading = 1;
      related(path).then(function (list) {
        grid.__lvLoading = 0;
        if (!list.length || !stockOnly() || !grid.isConnected || grid.querySelector(':scope > .lv-more-options')) return;
        busy(grid, function () { grid.appendChild(build(list, true)); });
      });
      return;
    }
    var sold = grid.querySelector(':scope > .t4s-product.is--sold-out');
    if (!sold) { if (box) busy(grid, function () { box.remove(); }); return; }
    if (box) { if (box.nextElementSibling !== sold) busy(grid, function () { grid.insertBefore(box, sold); }); return; }
    if (grid.__lvLoading) return;
    grid.__lvLoading = 1;
    related(path).then(function (list) {
      grid.__lvLoading = 0;
      var s = grid.querySelector(':scope > .t4s-product.is--sold-out');
      if (!list.length || !s || stockOnly() || !grid.isConnected || grid.querySelector(':scope > .lv-more-options')) return;
      busy(grid, function () { grid.insertBefore(build(list, false), s); });
    });
  }
  function boost(grid) {
    grid.querySelectorAll('.lazyloadt4s:not([data-expand])').forEach(function (el) { el.setAttribute('data-expand', '1600'); });
  }
  function prepare(grid) {
    if (grid.closest('.flickityt4s, .flickity-enabled')) return;
    if (!grid.__lvS) {
      grid.__lvS = 1;
      new MutationObserver(function () {
        if (grid.__lvBusy) return;
        clearTimeout(grid.__lvT);
        grid.__lvT = setTimeout(function () { sortSold(grid); banner(grid); boost(grid); }, 200);
        clearTimeout(grid.__lvT2);
        grid.__lvT2 = setTimeout(function () { banner(grid); }, 1400);
      }).observe(grid, { childList: true });
    }
    sortSold(grid); banner(grid);
  }

  /* In stock by default (once per page load, not when the shopper chose otherwise). */
  var auto = 0; /* 1 = asked for, 2 = in stock is showing */
  function stockDefault() {
    if (!/\/collections\/[^/]+\/?$/.test(location.pathname)) return;
    if (/[?&](filter\.|view=|q=)/.test(location.search)) return;
    try { if (sessionStorage.getItem('lv_all') === '1') return; } catch (e) {}
    var inN = facetCount(1), outN = facetCount(0);
    if (!inN || !outN) return;
    var p = params(); p.set('filter.v.availability', '1');
    auto = 1;
    nativeFilter(location.pathname + '?' + p.toString());
  }
  function afterSwap() {
    if (auto === 1 && stockOnly()) auto = 2;
    else if (auto === 2 && !stockOnly()) { setAll(); auto = 0; }
    document.querySelectorAll('#MainContent .t4s_box_pr_grid').forEach(function (g) { if (!g.__lvS) prepare(g); });
  }

  function start() {
    var main = document.getElementById('MainContent');
    if (main && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(afterSwap, 120); }).observe(main, { childList: true, subtree: true });
    }
    /* 19 Oct 2026, owner's decision: no automatic "In stock" filter. Collections open with all items; sold-out items move to the end, after the "Looking for more options?" row. Shoppers can still use the In stock filter themselves. */
    document.querySelectorAll('#MainContent .t4s_box_pr_grid').forEach(function (g) { if (!g.__lvS) prepare(g); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Livish (18 Oct 2026): the one-time offer also shows in the cart drawer (side bar) on every page except the cart page.
   The offer file is tiny and loads only when the browser is idle after the page, or when the cart icon is tapped. Undo: delete this block. */
(function () {
  if (/template-cart/.test(document.body.className)) return;
  var me = document.querySelector('script[src*="livish-fixes-4.js"]'), VER = '20261019-d8';
  if (!me) return;
  function load() {
    if (window.__lvDrOff || !document.getElementById('t4s-mini_cart')) return;
    window.__lvDrOff = 1;
    var s = document.createElement('script');
    s.src = me.src.replace('livish-fixes-4.js', 'livish-drawer-offer.js').replace(/([?&])v=[^&]*/, '$1v=' + VER); s.defer = true;
    document.body.appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
  document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('[data-drawer-options*="mini_cart"]')) load(); }, true);
})();
/* Livish (19 Oct 2026): offer rows (side cart and cart page) on computers. A mouse cannot swipe, so the row gets < > arrow buttons and the mouse wheel scrolls it sideways. Phones keep normal swiping (nothing changes there). Undo: delete this block. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var SEL = '.lv-dr__track, .lv-offer__track';
  var st = document.createElement('style');
  st.textContent = '.lv-trk-wrap{position:relative}' +
    '.lv-trk-btn{position:absolute;top:calc(50% - 30px);z-index:3;width:34px;height:34px;padding:0;border:1px solid #eadfe0;border-radius:50%;background:#fff;color:#770114;box-shadow:0 2px 10px rgba(0,0,0,.14);display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:22px;line-height:1}' +
    '.lv-trk-btn:hover{background:#770114;color:#fff}.lv-trk-btn[hidden]{display:none}' +
    '.lv-trk-prev{inset-inline-start:2px}.lv-trk-next{inset-inline-end:2px}' +
    '.lv-trk-btn span{display:inline-block;direction:ltr;unicode-bidi:isolate}[dir=rtl] .lv-trk-btn span{transform:scaleX(-1)}';
  document.head.appendChild(st);
  function setup(t) {
    if (t.__lvTrk || !t.parentNode) return;
    t.__lvTrk = 1;
    var rtl = getComputedStyle(t).direction === 'rtl', sign = rtl ? -1 : 1;
    var w = document.createElement('div');
    w.className = 'lv-trk-wrap';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
    function btn(cls, ch, dir, label) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lv-trk-btn ' + cls; b.setAttribute('aria-label', label);
      b.innerHTML = '<span aria-hidden="true">' + ch + '</span>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); t.scrollBy({ left: dir * sign * Math.max(140, t.clientWidth * 0.8), behavior: 'smooth' }); }, true);
      w.appendChild(b);
      return b;
    }
    var ar = /^ar/i.test(document.documentElement.lang || '');
    var p = btn('lv-trk-prev', '&#8249;', -1, ar ? 'السابق' : 'Previous');
    var n = btn('lv-trk-next', '&#8250;', 1, ar ? 'التالي' : 'Next');
    function upd() { var max = t.scrollWidth - t.clientWidth, x = Math.abs(t.scrollLeft); p.hidden = x < 4; n.hidden = max < 4 || x > max - 4; }
    t.addEventListener('scroll', upd, { passive: true });
    upd(); setTimeout(upd, 300); setTimeout(upd, 1200);
    t.addEventListener('wheel', function (e) {
      var max = t.scrollWidth - t.clientWidth;
      if (max < 4 || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var x = Math.abs(t.scrollLeft);
      if ((e.deltaY < 0 && x < 2) || (e.deltaY > 0 && x > max - 2)) return; /* at the end: let the page scroll */
      e.preventDefault();
      t.scrollLeft += sign * e.deltaY;
    }, { passive: false });
  }
  var q = 0;
  function scan() { q = 0; document.querySelectorAll(SEL).forEach(setup); }
  new MutationObserver(function () { if (!q) q = requestAnimationFrame(scan); }).observe(document.body, { childList: true, subtree: true });
  scan();
})();

/* Livish (19 Oct 2026): fix for "Load Previous" showing after reload / back button on collection pages.
   The theme's infinite scroll rewrites the address to ?page=2 while a shopper scrolls. Coming back
   (back button, reload, return from a product) then opens page 2 alone: only the last few products
   plus a "Load Previous" button. This keeps the address clean (page number removed) so the shopper
   always returns to the full list from the top. Loading more products still works the same.
   Only collection pages. Undo: delete this block. */
(function () {
  if (!/\/collections\//.test(location.pathname)) return;
  ['replaceState', 'pushState'].forEach(function (n) {
    var orig = history[n];
    if (!orig) return;
    history[n] = function (s, t, u) {
      try {
        if (typeof u === 'string' && /[?&]page=\d/.test(u)) {
          var x = new URL(u, location.href);
          if (x.pathname === location.pathname) { x.searchParams.delete('page'); u = x.pathname + x.search + x.hash; }
        }
      } catch (e) {}
      return orig.call(this, s, t, u);
    };
  });
})();

/* Livish: AI search page fixes (17 Oct 2026), carried over from the live theme so publishing does not remove them. */
/* Livish (17 Oct 2026): AI search page sort menu closes as soon as a sort
   option is picked (the results already re-sort; before, the menu stayed open
   until "Show results" was tapped). */
(function () {
  var key = '';
  document.addEventListener('pointerdown', function (e) {
    var c = e.target.closest && e.target.closest('.ryzo-mfb-chip');
    if (c) key = c.getAttribute('data-chip-key') || '';
  }, true);
  document.addEventListener('click', function (e) {
    var v = e.target.closest && e.target.closest('.ryzo-mfb-panel .ryzo-mfb-value');
    if (!v || key !== '__sort__') return;
    setTimeout(function () {
      var s = document.querySelector('.ryzo-mfb-panel .ryzo-mfb-show');
      if (s) s.click();
    }, 150);
  }, true);
})();
/* Livish (17 Oct 2026): AI search page, desktop sidebar: the "Tags" filter box
   (internal English tags and supplier names) is hidden, as on phones. */
(function () {
  if (!/search-results/.test(location.pathname)) return;
  var raf = 0;
  function hide() {
    raf = 0;
    document.querySelectorAll('.ryzo-check-card').forEach(function (c) {
      var t = c.querySelector('.ryzo-check-card-title');
      if (t && /^\s*Tags\s*$/i.test(t.textContent) && c.style.display !== 'none') c.style.display = 'none';
    });
  }
  hide();
  new MutationObserver(function () { if (!raf) raf = requestAnimationFrame(hide); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
/* AI search page (17 Oct 2026): a close (X) button on the Sort / filter panel, in English and Arabic.
   Before, the only way to close it was tapping "Sort" again. X closes the panel the same way. */
(function () {
  if (!/search-results/.test(location.pathname)) return;
  var ar = /^ar/i.test(document.documentElement.lang || '');
  var lastChip = null, raf = 0;
  document.addEventListener('pointerdown', function (e) {
    var c = e.target.closest && e.target.closest('.ryzo-mfb-chip');
    if (c) lastChip = c;
  }, true);
  var st = document.createElement('style');
  st.textContent = '.ryzo-mfb-panel{position:relative}.lv-mfb-x{position:absolute;top:6px;inset-inline-end:6px;z-index:5;width:36px;height:36px;border:1px solid #e6dadb;border-radius:50%;background:#fff;color:#2b0a10;font:inherit;font-size:20px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0}.lv-mfb-x:focus-visible{outline:2px solid #770114;outline-offset:2px}.ryzo-mfb-panel:has(.lv-mfb-x){padding-top:44px!important}';
  document.head.appendChild(st);
  function close() {
    var c = lastChip && document.body.contains(lastChip) ? lastChip : document.querySelector('.ryzo-mfb-chip[aria-expanded="true"], .ryzo-mfb-chip.is-active, .ryzo-mfb-chip.active');
    if (c) c.click();
  }
  function add() {
    raf = 0;
    document.querySelectorAll('.ryzo-mfb-panel').forEach(function (p) {
      if (p.querySelector(':scope > .lv-mfb-x')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lv-mfb-x';
      b.setAttribute('aria-label', ar ? 'إغلاق' : 'Close');
      b.title = ar ? 'إغلاق' : 'Close';
      b.innerHTML = '<span aria-hidden="true">×</span>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
      p.insertBefore(b, p.firstChild);
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.querySelector('.ryzo-mfb-panel .lv-mfb-x')) close(); });
  add();
  new MutationObserver(function () { if (!raf) raf = requestAnimationFrame(add); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* Livish (20 Oct 2026): Arabic wording for the new Salons entries (menu, categories panel, home tile) and the salon booking button.
   Until these labels are added in the theme translations, they are swapped here. Arabic pages only; nothing changes in English. Undo: delete this block. */
(function () {
  if (!/^ar/i.test(document.documentElement.lang || '')) return;
  var MAP = { 'Salons & Spa': 'الصالونات والسبا', 'All Salon Deals': 'كل عروض الصالونات' };
  var q = 0;
  function fix() {
    q = 0;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n, hit = [];
    while ((n = w.nextNode())) { if (MAP[n.nodeValue.trim()]) hit.push(n); }
    hit.forEach(function (t) { t.nodeValue = t.nodeValue.replace(/\S[\s\S]*\S|\S/, function (m) { return MAP[m.trim()] || m; }); });
    if (document.querySelector('.lv-service-select-heading')) {
      document.querySelectorAll('.shopify-payment-button__button').forEach(function (b) { if (b.textContent.trim() === 'شراء الآن') b.textContent = 'احجزي الآن'; });
    }
  }
  function start() {
    fix();
    new MutationObserver(function () { if (!q) q = setTimeout(fix, 80); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Livish (20 Oct 2026): salon booking page, short note under the Book Now button: the booking code arrives by email and WhatsApp after purchase. EN/AR. Salon product page only (the one with the service heading). Undo: delete this block and the .lv-book-note rules in livish-fixes-4.css. */
(function () {
  var ar = /^ar/i.test(document.documentElement.lang || '');
  function add() {
    if (!document.querySelector('.lv-service-select-heading') || document.querySelector('.lv-book-note')) return;
    var form = document.querySelector('.t4s-product__info-container form[data-type="add-to-cart-form"]');
    if (!form || !form.parentNode) return;
    var box = document.createElement('div');
    box.className = 'lv-book-note';
    if (ar) box.setAttribute('dir', 'rtl');
    box.innerHTML = '<span class="lv-book-note__ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="3"/><path d="m4 7.5 8 6 8-6"/></svg></span>' +
      '<span class="lv-book-note__tx"><strong>' + (ar ? 'كود الحجز' : 'Your booking code') + '</strong><span>' +
      (ar ? 'بعد إتمام الشراء، يُرجى التواصل مع الصالون لتحديد موعدك. سيتم إرسال كود الحجز عبر الواتساب والبريد الإلكتروني لتقديمه عند الوصول.' : 'Following your purchase, please contact the salon to schedule your appointment. Your booking code will be sent via WhatsApp and email to present upon arrival.') +
      '</span></span>';
    form.parentNode.insertBefore(box, form.nextSibling);
  }
  function start() {
    add();
    var q = 0;
    new MutationObserver(function () { if (!q) q = setTimeout(function () { q = 0; add(); }, 120); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
